import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AddShoppingCart, Fastfood } from '@material-ui/icons';
import { isEmpty } from 'lodash';
import Image from 'material-ui-image';
import React, { FC } from 'react';
import { OnlineOrderingStore, OrderingItem } from 'kiolyn-api';
import { isNullOrUndefined } from 'util';
import CurrencyFormat from '../../../Core/CurrencyFormat/CurrencyFormat';
import { useOrdering } from '../../../../stores/OrderingStore';

const useStyles = makeStyles(() => ({
  itemList: {
    width: '100%',
    maxWidth: '100%'
  },
  itemAvatarWrapper: {
    width: 40,
    height: 40,
    margin: 0
  }
}));

interface ItemListProps {
  items?: OrderingItem[];
  getUnavailableMessage?: (item: OrderingItem) => string;
  onSelect?: (item: OrderingItem) => void;
  acceptOrdering?: boolean;
}

const ItemList: FC<ItemListProps> = ({
  items,
  getUnavailableMessage,
  onSelect,
  acceptOrdering
}: ItemListProps) => {
  const classes = useStyles();
  const orderingStore = useOrdering();
  const store = orderingStore.store as OnlineOrderingStore;

  if (isNullOrUndefined(items) || isEmpty(items)) {
    return null;
  }

  const handleSelect = (item: OrderingItem) => {
    if (
      acceptOrdering === true &&
      (isNullOrUndefined(item.out_of_stock) ||
        item.out_of_stock === 'In-stock' ||
        item.out_of_stock === '') &&
      !isNullOrUndefined(onSelect) &&
      (isNullOrUndefined(getUnavailableMessage) ||
        isEmpty(getUnavailableMessage(item)))
    ) {
      onSelect(item);
    }
  };

  return (
    <List className={classes.itemList} dense>
      {items.map(item => [
        <ListItem key={item.id} onClick={() => handleSelect(item)}>
          <ListItemAvatar>
            <Avatar>
              {isNullOrUndefined(item.imageURL) || isEmpty(item.imageURL) ? (
                <Fastfood />
              ) : (
                <Box className={classes.itemAvatarWrapper}>
                  <Image
                    disableSpinner
                    src={item.imageURL || ''}
                    imageStyle={{
                      objectFit: 'cover',
                      width: '100%'
                    }}
                  />
                </Box>
              )}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Box>
                <Typography variant="body1" color="textPrimary">
                  {item.name || ' '}
                  {store.show_name_2 &&
                    !isNullOrUndefined(item.name2) &&
                    ' (' + item.name2 + ')'}
                </Typography>
                <Typography variant="body1" color="secondary">
                  <CurrencyFormat amount={item.price} />
                </Typography>
              </Box>
            }
            secondary={
              <Typography component="span">
                <Typography variant="body2" color="textSecondary">
                  {item.description || ''}
                </Typography>
                <Typography variant="body2" color="error">
                  {(!isNullOrUndefined(getUnavailableMessage) &&
                    getUnavailableMessage(item)) ||
                    ''}
                </Typography>
                <Typography variant="body2" color="error">
                  {(!isNullOrUndefined(item.out_of_stock) &&
                    item.out_of_stock !== '' &&
                    'Out of stock ' + item.out_of_stock) ||
                    ''}
                </Typography>
              </Typography>
            }
          />
          {acceptOrdering &&
            (isNullOrUndefined(item.out_of_stock) ||
              item.out_of_stock === 'In-stock') &&
            (isNullOrUndefined(getUnavailableMessage) ||
              isEmpty(getUnavailableMessage(item))) && (
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  aria-label="add item"
                  onClick={() => handleSelect(item)}
                >
                  <AddShoppingCart />
                </IconButton>
              </ListItemSecondaryAction>
            )}
        </ListItem>,
        <Divider key={item.id + 'Divider'} variant="inset" component="li" />
      ])}
    </List>
  );
};

export default ItemList;
